interface OrgPermissions {
  schedule_publish: number
}

interface All {
  all: boolean
}

interface StoryPermissions {
  circulate: All
  cloneStory: All
  commentModeration: All
  createStory: All
  deleteStory: All
  devAdmin: boolean
  editPrimaryWebsite: All
  editStory: All
  forceRelinquish: All
  initialPublish: All
  publish: All
  scheduleUnpublish: All
  settings: All
  subsequentPublish: All
  unpublish: All
  urlRegeneration: All
  viewStory: All
}

interface OrgPermissions {
  schedule_publish: number
}

interface All {
  all: boolean
}

interface StoryPermissions {
  circulate: All
  cloneStory: All
  commentModeration: All
  createStory: All
  deleteStory: All
  devAdmin: boolean
  editPrimaryWebsite: All
  editStory: All
  forceRelinquish: All
  initialPublish: All
  publish: All
  scheduleUnpublish: All
  settings: All
  subsequentPublish: All
  unpublish: All
  urlRegeneration: All
  viewStory: All
}

export interface Permissions {
  org: OrgPermissions
  story: StoryPermissions
}

// docs: https://arcpublishing.atlassian.net/wiki/spaces/STOR/pages/307495632/Ellipsis+Permissions
export const hasPermission = (
  permissionObj: All | boolean,
  websiteId?: string
) => {
  // if no permissions
  if (!permissionObj) {
    return false
  }

  // if legacy permissions
  if (typeof permissionObj === 'boolean') {
    return permissionObj
  }

  const permissionsKeys = Object.keys(permissionObj)

  // if user has access to all
  if (
    permissionObj.all ||
    // if canonical website, check if user has access to canonical website
    (websiteId && permissionObj[websiteId.toLowerCase()]) ||
    // If no canonical website but user has access to one website
    (!websiteId && permissionsKeys.some((k) => permissionObj[k]))
  ) {
    return true
  }

  return false
}
